import { render, staticRenderFns } from "./PageEventRankDetail.vue?vue&type=template&id=c506d056&scoped=true&"
import script from "./PageEventRankDetail.vue?vue&type=script&lang=js&"
export * from "./PageEventRankDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageEventRankDetail.vue?vue&type=style&index=0&id=c506d056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c506d056",
  null
  
)

export default component.exports